export const bodyEl = document.querySelector('body');
export const btnsGroupForChangeForm = document.querySelector('.sign-wrap');
export const formsForRegistration = document.querySelector('.form__inner');
export const backdropEl = document.querySelector('.backdrop--form');
export const formForSignEl = document.querySelector('[data-formForSign]');
export const formForUserFotoEl = document.querySelector(
  '[data-formForUserFoto]'
);

export const btnsClose = document.querySelectorAll('.btn-close');

export const formSignUp = document.querySelector('.form[name="sign-up"]');
export const formSignIn = document.querySelector('.form[name="sign-in"]');
export const formChangeFoto = document.querySelector('.form[name="add-foto"]');

// header
export const reversEntrance = document.querySelectorAll('[data-user="log-in"]');
export const reversExit = document.querySelectorAll('[data-user="log-out"]');
export const userDisplayName = document.querySelectorAll('[data-user="name"]');
export const btnsLogOut = document.querySelectorAll('.js-log-out');
export const btnChangeFoto = document.querySelector(
  '[data-user="changePhoto"]'
);

// Imgs with photo user
export const imageFotoEls = document.querySelectorAll('[data-userFoto]');

// modal card for book
export const btnForModal = document.querySelector('.modal_button');

export const USER_DATA_KEY_STORAGE = 'user-data';
